module.exports = __webpack_public_path__ + "static/media/8.78221ab2.JPG";